import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-driver-app-installation-report',
  templateUrl: './driver-app-installation-report.component.html',
  styleUrls: ['./driver-app-installation-report.component.css']
})
export class DriverAppInstallationReportComponent implements OnInit {

  public driverAppData = [];


  public showTable: boolean = true;
  public tableData: any = [];
  public cols: any = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Driver name',headerConfig:{ isDefault: true} },
    {
      key: 'mobile', display: 'Mobile no',headerConfig:{ isDefault: true}
    },
    {
      key: 'branch', display: 'Branch',
    },
    {
      key: 'shift', display: 'Shift',
    },
    {
      key: 'vendorName', display: 'Vendor name',headerConfig:{ isDefault: true}
    },
    // { key: 'lastLogin', display: 'Last Login' },
    {
      key: 'lastLoginTime', display: 'Last login time', config: {
        isDate: true,
        format: 'dd/MM/YYYY HH:mm:ss'
      },
      headerConfig:{ isDefault: true}
    },
  ];
  public noDataFoundEnable: boolean = false;

  /* Excel */
  public driverAppExlData:any = [];
  public branchData = {};
  public shiftData = {};
  public vendorData = {};
  public excelData = {};
  public exlNoDataFound = false;
  public showDownloadBtn: boolean = true;

  public matFormSize = '12px';
  public filterForm: FormGroup;

  public maxDate = new Date();
  public maxEndDate = new Date();

  public localStorage;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public formSubmitted: boolean = false;


  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 25,
    totalPage: 1,
  };
  public filterData = {};

  constructor(
    private api: ApiService,
    private storage: StorageService,
    private fb: FormBuilder,
    private com: CommonServices,
    private excel: ExcelExportService,
  ) {
    this.filterFormLoad();
  }

  ngOnInit(): void {
    let obj = {
      startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
      endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
    }
    this.getDriverAppExlReport(obj);
    this.getDriverAppReport(1, this.paginationData.limit, obj);
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({
      search: new FormControl(''),
      startDate: new FormControl(new Date(), [Validators.required]),
      endDate: new FormControl(new Date(), [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
    } else {
      this.maxEndDate = new Date();
    }
  }

  validation(data) {
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['endDate'] = 'Invalid end date';
        }else if(new Date(this.maxEndDate).getTime() < new Date(data.endDate).getTime()){
          isValid = false;
          this.errorObject['endDate'] = "Maximum 30 days can be select"
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    // console.log(this.sosForm.value);
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.filterForm.value.search != '') obj['search'] = this.filterForm.value.search;
      this.getDriverAppExlReport(obj);
      this.getDriverAppReport(1, this.paginationData.limit, obj);
    }
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getDriverAppReport(data.page, data.limit, filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
  }

  getDriverAppReport(page: number = 1, limit = 10, filter = null) {
    let obj = { page, limit };
    if (filter) {
      obj = { ...obj, ...filter };
    }
    this.api.transportManagerDriverAppReports(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.driverAppData = res['data'];
          if(res['branch'] && Object.keys(res['branch']).length>0) this.branchData = { ...this.branchData,...res['branch']};
          if(res['shift'] && Object.keys(res['shift']).length>0) this.shiftData = { ...this.shiftData,...res['shift']};
          if(res['vendor'] && Object.keys(res['vendor']).length>0) this.vendorData = { ...this.vendorData,...res['vendor']};
          this.processTableData();
          // this.tableData = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        // this.processPagination(res, obj);
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('err', err);
    })

  }

  processTableData() {
    this.showTable = false;
    this.tableData = this.driverAppData.map((res: any) => {
      let obj = {
        name: res.name ? res.name : '',
        vendorName: res.vendorID && this.vendorData[res.vendorID] ? this.vendorData[res.vendorID] : '',
        branch: res.branch && this.branchData[res.branch] ? this.branchData[res.branch] : '',
        shift: res.shift ? this.getShiftName(res.shift) : '',
        mobile: res.mobile ? res.mobile : '',
        lastLoginTime: res.lastLoginTime ? res.lastLoginTime : '',  
      }
      return obj;
    });
    setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true; }, 100);
  }

  getShiftName(shift){
    let shiftName = '';
    if(shift){
      if(!Array.isArray(shift)) shift = [ shift];
      if(shift.length > 0){
        let shiftNames = shift.map((shift)=>{ 
          if(shift && this.shiftData[shift]) return this.com.convertTitleCase(this.shiftData[shift])
        });
        shiftNames = [ ...shiftNames];
        shiftName = shiftNames.join(', ');
      }
    }
    return shiftName;
  }

  getDriverAppExlReport(obj){
      this.driverAppExlData = [];
      this.api.transportManagerDriverAppExlReports(obj).then(async (res: any) => {
          if (res && res.data && res.data.length > 0) {
              this.driverAppExlData = res.data;
              if(res['branch'] && Object.keys(res['branch']).length>0) this.branchData = { ...this.branchData,...res['branch']};
              if(res['shift'] && Object.keys(res['shift']).length>0) this.shiftData = { ...this.shiftData, ...res['shift']};
              if(res['vendor'] && Object.keys(res['vendor']).length>0) this.vendorData = { ...this.vendorData,...res['vendor']};
              this.exlNoDataFound  = false;
          }else{
            this.exlNoDataFound = true;
          }
      }).catch((err) => { this.exlNoDataFound = true; console.log(err) })
  }

  async exportToExcel() {
    let data = [];   
    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));
    for (let i = 0; i < this.driverAppExlData.length; i++) {
      let item = this.driverAppExlData[i];
      try {     
        let res = {
          value: [
            i + 1,
            item.name ? this.com.convertTitleCase(item.name) : '---',
            item.mobile ? item.mobile : '---',
            item.branch ? this.com.convertTitleCase(this.branchData[item.branch]) : '---',
            item.shift ? (this.getShiftName(item.shift)!='' ? this.getShiftName(item.shift) : '---') : '---',
            item.vendorID ? this.com.convertTitleCase(this.vendorData[item.vendorID]) : '---',
            item.lastLoginTime ? this.com.timestampToDate(item.lastLoginTime,'DMY H:M:S') : '---',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }


    if (data.length > 0) {

      let rowCount = 2;
      let endCell = 'G';
      let customizedData = [];
      let titleRow = {
        value: ['Driver App Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },

        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Driver name', 'Mobile no','Branch','Shift','Vendor name','Last login time'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);

      if (this.excelData['Driver_App_Report'] == undefined) { this.excelData['Driver_App_Report'] = {}; }

      this.excelData['Driver_App_Report'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 15 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 },{ colNo: 6, width: 15 },{ colNo: 7, width: 25 }]
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Driver_App_Report.xlsx');
  }

}
